<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">

            </h2>
        </template>

        <div>
            <div class="max-w-7xl m-4 py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <h2 class="text-xl mb-4"><span class='font-bold'>Required Action:</span> Complete A2P Registration</h2>
                <p class="mb-4">This registration is required by wireless carriers in order to send messages from applications like TextSpot.</p>

                <p class="mb-2">Important details to keep in mind:</p>
                <ul class="ul list-disc pl-8">
                <li><strong>One time application fee of $19</strong></li>
                <li><strong>Business EIN or CCN is required</strong> (not a business? <a @click="openIntercom" class="text-blue-500 cursor-pointer">contact support</a>)</li>
                </ul>
                <br />

                <p class="mb-4">Once you submit the application, our team will review your application for any errors. If we need to make any corrections we will email you. If no corrections are needed, your application will be submitted to the <a class='text-blue-500 cursor-pointer' href='https://www.campaignregistry.com/' target="_blank">Campaign Registry</a> for review.</p>

                <p class="mb-4">We will notify you if and when your organization is verified (this is currently taking {{  $page.props.approval_time_wording }}).</p>

                <p class="mb-4">Once approved you'll be able to start sending messages to your contacts.</p>

                <Link href="/verified/step-1" >
                    <jet-button class="mt-8 mb-4">
                        Start the application
                    </jet-button>
                </Link>

                <p class='italic'>If you have any additional questions, please review our <a class="text-blue-500 cursor-pointer" href="https://textspot.io/resources/a2p-guide/" target="_blank">A2P Resource Page</a>.</p>
            </div>
        </div>
    </app-layout>
</template>

<script setup>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";

const openIntercom = () => {
    if (typeof window !== "undefined" && typeof window.Intercom === "function") {
        window.Intercom("show");
    }
};
</script>
